import { Text, CoreButton } from '@vitvio/design-system';
import { GenericErrorPage } from './GenericErrorPage';

/**
 * Page displayed when the app cannot connect to the server on initial load.
 * This is shown only when the connection check fails on first mount or hard refresh.
 */
export function NoConnectionPage() {
  return (
    <GenericErrorPage errorHeadingText="common:error.noConnectionTitle">
      <Text
        path="common:error.noConnectionDescription"
        // TODO: All of these attributes need to be derived from the font attribute, not hardcoded
        fontSize="normal"
      />
      <CoreButton
        label="common:button.reload"
        onClick={() => (window.location.href = '/')}
        type="primary"
        size={'lg'}
        width="auto"
      />
    </GenericErrorPage>
  );
}
